<template>
  <div class="grid grid-cols-1 xs:grid-cols-2 gap-3">
    <div
      v-for="key in numberOfCards"
      :key="key"
      class="bg-white col-span-1 rounded-md p-3 flex items-center gap-2">
      <PVSkeleton width="11rem" height="100%"></PVSkeleton>
      <div class="fle flex-col items-start h-full w-full">
        <div class="w-full flex justify-end gap-1">
          <PVSkeleton size="2rem"></PVSkeleton>
          <PVSkeleton size="2rem"></PVSkeleton>
        </div>
        <PVSkeleton width="10rem" class="mb-2"></PVSkeleton>
        <PVSkeleton width="6rem" height=".5rem"></PVSkeleton>
        <div class="w-full flex justify-end gap-1">
          <PVSkeleton
            width="5rem"
            height="1.4rem"
            border-radius="99px"></PVSkeleton>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PVSkeleton from 'primevue/skeleton';

defineProps({
  numberOfCards: {
    type: Number,
    default: 3,
  },
});
</script>
